import React from 'react';
import Button from 'carbon-react/lib/components/button';
import Form from 'carbon-react/lib/components/form';
import Typography from 'carbon-react/lib/components/typography';

import { ContactDetails } from '@futrli-sdk/predict';
import { FormattedMessage, useIntl } from '@futrli/localisation';
import { Sidebar, UILoaderSpinner } from '@futrli/ui-components';

import { Dependency } from './dependency';
import { Overview } from './overview';
import { PaymentsTrends } from './payment-trends';
import { RiskTrend } from './risk-trend';

interface Props {
  activeCustomerSupplier?: ContactDetails;
  isOpen: boolean;
  isLoading: boolean;
  onClose: () => void;
}

export const CustomersSuppliersSidePanel = ({ activeCustomerSupplier, isOpen, isLoading, onClose }: Props) => {
  const intl = useIntl();

  return (
    <Sidebar
      open={isOpen}
      aria-label={intl.formatMessage({
        id: 'predict.contact_deep_dive',
        defaultMessage: 'Contact deep dive'
      })}
      size="medium-large"
      header={
        <>
          <Typography variant="h2" fontWeight="700">
            <FormattedMessage id="predict.deep_dive" defaultMessage="Deep dive" />
          </Typography>
          <Typography variant="p" fontWeight="400" color="#000" mb={0} mt="8px" fontSize="16px">
            {activeCustomerSupplier?.name}
          </Typography>
        </>
      }
      onCancel={onClose}
    >
      <aside style={{ height: '100%' }}>
        <Form
          rightSideButtons={
            <Button onClick={onClose}>
              <FormattedMessage id="common.close" defaultMessage="Close" />
            </Button>
          }
          stickyFooter
          buttonAlignment="right"
          footerPadding={{
            p: 2
          }}
          onSubmit={e => e.preventDefault()}
        >
          {isLoading ? (
            <UILoaderSpinner />
          ) : (
            <>
              <Overview activeData={activeCustomerSupplier} />

              <PaymentsTrends activeData={activeCustomerSupplier} />

              <RiskTrend activeData={activeCustomerSupplier} />

              <Dependency activeData={activeCustomerSupplier} />
            </>
          )}
        </Form>
      </aside>
    </Sidebar>
  );
};
